import Vue from "vue";
import VueRouter from "vue-router";
import authentication from "./components/authentication.vue";
import upgradeplan from "./views/ysy/upgradeplan";
import {store} from './store'
import DashboardLayout from './views/YsyLinkedin/SampleLayout.vue';
import DashboardLayoutInstagram from './views/YsyInstagram/SampleLayout.vue';
import YsyDashboard from './components/DashboardUser.vue'
import YsyDashboardInstagram from './views/YsyInstagram/setUserConfigurationInstagram'
import Landing from './views/HomeSoftware.vue';

import AddNewInstagramAccount from './views/YsyInstagram/addNewInstagramAccount'

import SetUserConfiguration from './views/setUserConfiguration.vue';
import SetUserConfigurationSalesNavigator from './views/setUserConfigurationSalesNavigator.vue';
import SetUserConfigurationInstagram from './views/YsyInstagram/setUserConfigurationInstagram';

import GetUserConfig from './views/UserLinkedinConfig.vue';
import GetUserConfigurationSalesNavigator from './views/UserLinkedinConfigSalesNavigator';
import GetUserConfigInstagram from './views/YsyInstagram/getUserConfigurationInstagram';

import GetUserReport from './views/UserLinkedinReport.vue';
import GetUserReportSalesNavigator from './views/UserLinkedinReportSalesNavigator.vue'
import GetUserReportInstagram from './views/YsyInstagram/getUserReportInstagram'

import Profile from './views/ysy/userProfile.vue'

import OrganicGrowth from './views/ysy/OrganicGrowth.vue'
import GetLicensesKey from './components/GetLicensesKey.vue'

import Logout from './components/logout.vue';

import Home from "./views/Home";
import Ysyterms from "./views/ysy/Ysyterms";
import YsyPrivacyPolicy from "./views/ysy/YsyPrivacyPolicy";
// import YsyRegister from "./views/ysy/Register";
import YsyLogin from "./views/ysy/YsyLogin";

import FacebookProfile from './views/YsyFacebook/userProfile'
import DashboardLayoutFacebook from './views/YsyFacebook/SampleLayout.vue';

Vue.use(VueRouter);
let routesInstagram =
  [{
    path: "/mysynchronicity-instagram",
    name: "Dashboard Instagram",
    component: DashboardLayoutInstagram,
    redirect: "/mysynchronicity-instagram/overview",
    children: [
      {
        path: 'overview',
        name: 'Overview Instagram',
        component: YsyDashboardInstagram,
        meta: {
          requiresAuth: true
        },
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
    {
      path: "/instagram",
      name: "Instagram Main Menu",
      redirect: "/instagram/set-user-configuration",
      component: DashboardLayoutInstagram,
      children: [
        {
          path: "add-new-instagram",
          name: "Add New Instagram",
          component: AddNewInstagramAccount,
          meta: {
            requiresAuth: true
          },
        }, {
          path: "set-user-configuration",
          name: "Set Instagram configuration",
          component: SetUserConfigurationInstagram,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "get-user-configuration",
          name: "Get Instagram Configuration",
          component: GetUserConfigInstagram,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: "get-user-report",
          name: 'Get Instagram Report',
          component: GetUserReportInstagram,
          meta: {
            requiresAuth: true
          },
        }
      ],
      meta: {
        requiresAuth: true
      },
    },
  ];
let routesFacebook =
  [
    //   {
    //   path: "/mysynchronicity-instagram",
    //   name: "Dashboard Instagram",
    //   component: DashboardLayoutInstagram,
    //   redirect: "/mysynchronicity-instagram/overview",
    //   children: [
    //     {
    //       path: 'overview',
    //       name: 'Overview Instagram',
    //       component: YsyDashboardInstagram,
    //       meta: {
    //         requiresAuth: true
    //       },
    //     }
    //   ],
    //   meta: {
    //     requiresAuth: true
    //   }
    // },

    {
      path: "/mysynchronicity-facebook",
      name: "Facebook Main Menu",
      component: DashboardLayoutFacebook,
      redirect: "/mysynchronicity-facebook/profile",
      children: [
        {
          path: "profile",
          name: "profile",
          component: FacebookProfile,
          meta: {
            requiresAuth: true
          },
        }
      ],
      meta: {
        requiresAuth: true
      },
    },
  ];

var routes = [
  {
    path: '/Home',
    name: 'home',
    component: DashboardLayout,
    children: [
      {
        path: 'display-contact-information',
        name: 'Home',
        component: Home
      }
    ]
  },
  {
    path: "/",
    name: "Landing",
    component: Landing,

  },
  // {
  //   path: "/register",
  //   name: "YsyRegister",
  //   component: YsyRegister,
  //
  // },
  {
    path: "/login",
    name: "login",
    component: YsyLogin,

  },
  {
    path: "/terms",
    name: "terms",
    component: Ysyterms,

  }, {
    path: "/privacy",
    name: "privacy",
    component: YsyPrivacyPolicy,

  },
  {
    path: "/mysynchronicity-linkedin",
    name: "Dashboard",
    component: DashboardLayout,
    redirect: "/mysynchronicity-linkedin/overview",
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: YsyDashboard,
        meta: {
          requiresAuth: true
        },
      }
    ],
    meta: {
      requiresAuth: true
    },
  },
  {
    path: "/linkedin",
    name: "Linkedin Main Menu",
    redirect: "/linkedin/set-user-configuration",
    component: DashboardLayout,
    children: [
      {
        path: "set-user-configuration",
        name: "Set LinkedIn configuration",
        component: SetUserConfiguration,
        meta: {
          requiresAuth: true
        },
      },
      {
        path: "get-user-configuration",
        name: "Get LinkedIn Configuration",
        component: GetUserConfig,
        meta: {
          requiresAuth: true
        },
      },
      {
        path: "get-user-report",
        name: 'Get Report',
        component: GetUserReport,
        meta: {
          requiresAuth: true
        },
      },
      {
        path: "profile",
        name: "Profile",
        component: Profile,
        meta: {
          requiresAuth: true
        },
      },
      {
        path: "organic-growth",
        name: "Organic Growth",
        component: OrganicGrowth,
        meta: {
          requiresAuth: true
        },
      }, {
        path: "admin-panel",
        name: "Admin Panel",
        component: GetLicensesKey,
        meta: {
          requiresAuth: true,
          requiresAdmin: true
        },
      },
      {
        path: "upgradeplan",
        name: "upgradeplan",
        component: upgradeplan,
        meta: {
          requiresAuth: true
        }
      },
    ],
    meta: {
      requiresAuth: true
    },
  },
  {
    path: "/linkedin/sales",
    name: "salesNavigatorLayout",
    redirect: "/linkedin/sales/set-user-configuration",
    component: DashboardLayout,
    children: [
      {
        path: "set-user-configuration",
        name: "set User Configuration Sales Navigator",
        component: SetUserConfigurationSalesNavigator,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "get-user-configuration",
        name: "Get User Config Sales Navigator",
        component: GetUserConfigurationSalesNavigator,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "get-user-report",
        name: "User Report Sales Navigator",
        component: GetUserReportSalesNavigator,
        meta: {
          requiresAuth: true
        }
      }

    ],
    meta: {
      requiresAuth: true
    },
  },

  {
    path: "/authentication",
    name: "authentication",
    component: authentication,

  },
  {
    path: "/logout",
    name: "logout",
    component: Logout,

  }
];
routes = routes.concat(routesInstagram);
routes = routes.concat(routesFacebook);

// ADMINISTRATOR YSY
import AdministratorYourSynchronicity from "./views/AdministratorYourSynchronicity";

routes = routes.concat([{
  path: "/adminysy",
  name: "adminysy",
  component: AdministratorYourSynchronicity,
  meta: {
    requiresAuth: true
  }
}]);
//
routes.push({path: '*', component: Logout});
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'active',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return {selector: to.hash};
    }
    return {x: 0, y: 0};
  }
});
var pathArrayExclude = []
router.options.routes.forEach(path => pathArrayExclude.push(path.path))
pathArrayExclude.splice(pathArrayExclude.indexOf('/Home'), 1);
pathArrayExclude.splice(pathArrayExclude.indexOf('/register'), 1);
pathArrayExclude.splice(pathArrayExclude.indexOf('/login'), 1);
pathArrayExclude.splice(pathArrayExclude.indexOf('/terms'), 1);
pathArrayExclude.splice(pathArrayExclude.indexOf('/privacy'), 1);
pathArrayExclude.splice(pathArrayExclude.indexOf('/linkedin/profile'), 1);
pathArrayExclude.splice(pathArrayExclude.indexOf('/authentication'), 1);
pathArrayExclude.splice(pathArrayExclude.indexOf('/logout'), 1);
pathArrayExclude.splice(pathArrayExclude.indexOf('/'), 1);
router.beforeEach((to, from, next) => {
  if (pathArrayExclude.includes(to.path)) {
    const user = store.getters.getStateLinkedin;
    if (user.isBlocked) {
      next({
        path: '/logout'
      });
      return
    }
  }
  //check authentication required
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      if (to.matched.some(record => record.meta.requiresAdmin)) {
        if (store.getters.getUserRole === "admin") {
          next();
          return
        } else {
          next({
            path: '/mysynchronicity-linkedin'
          });
        }
      }
      next();
      return
    }
    window.location = "https://upgrademe.auth.eu-west-1.amazoncognito.com/login?response_type=code&client_id=14la992522it9l4gke47sduju&redirect_uri=https://www.yoursynchronicity.com/authentication"
    // this.$router.push({name: 'login'});

  } else {
    next()
  }
});

export default router;
